import { SubAreaContent } from "../contentManager/SubAreaContent";

import "./CheckUps.scss";

export const Checkups = () => {
    return <div className="checkups-container">
        <h2>CheckUps</h2>
        <SubAreaContent isProjectSpecific={true} area="checkups" />
    </div>;
};